import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


export class NotAuthenticatedError {}

@Injectable()
export class BpoHttpInterceptor implements HttpInterceptor {

    constructor(private auth: AuthService,
           private router: Router,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {        
        // 🔹 Se for callback, não faz nada de auth        
        if (
            req.url.includes('/authorization-url') ||
            req.url.includes('/callback') ||
            req.url.includes('/auth')
        ) {
            return next.handle(req);
        }
        if(!this.auth.isAccessTokenInvalido()){
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
        }

        if (this.auth.isAccessTokenInvalido()) {

        return from(this.auth.obterNovoAccessToken())
            .pipe(
                mergeMap(() => {
                  if (this.auth.isAccessTokenInvalido()) {
                    this.router.navigate(['login']);
                    throw new NotAuthenticatedError()
                }
                    req = req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    return next.handle(req);
                })
            );
        }           

        return next.handle(req);
    }
}
